import React, { useEffect, useState, useRef } from 'react';
import StickyBox from 'react-sticky-box';
import styles from './ConfigurationsBox.module.css';

const ConfigurationsBox = (props) => {
  const boxRef = useRef();
  const [isBoxOpened, setIsBoxOpened] = useState(false);
  const [content, setContent] = useState(null);
  const [width, setWidth] = useState('m4');
  const [scroll, setScroll] = useState(false);
  const [withBackdrop, setWithBackdrop] = useState(true);

  useEffect(() => {
    if (props.children) {
      setContent(
        React.cloneElement(props.children, {
          setBoxOpened: setIsBoxOpened,
          boxRef,
          setWidth,
          setScroll,
          setWithBackdrop,
        }),
      );
    } else {
      setContent(null);
      setIsBoxOpened(false);
    }
  }, [props.children], isBoxOpened);

  const boxClassToogle = isBoxOpened
    ? styles.CompConfShow
    : styles.CompConfHidden;

  return (
    <>
      { withBackdrop ? (
        <div
          className={`backdrop ${styles.Backdrop}`}
          style={{
            visibility: `${isBoxOpened ? 'visible' : 'hidden'}`,
          }}
        />
      ) : null}
      <div className={`${styles.CompConf} ${styles[width]} ${boxClassToogle}`}>
        <StickyBox offsetTop={0} style={{ zIndex: 5 }} className={styles.BoxBorder}>
          <div ref={boxRef} className={`${styles.Content} ${scroll ? styles.Scroll : null}`}>
            {content}
          </div>
        </StickyBox>
      </div>
    </>
  );
};

export default ConfigurationsBox;
